/**
 * Schema.org FAQPage JSON-LD builder (SSoT).
 *
 * Örnekler hub'ları (risk-analizi / saha-gozlem / yillik-calisma-plani /
 * yillik-egitim-plani) görünür "Sıkça Sorulan Sorular" bölümünü ZATEN render ediyordu
 * ama FAQPage structured data EMIT ETMİYORDU → AI Overview / ChatGPT / Perplexity bu
 * Q&A'ları "citation-ready passage" olarak göremiyordu. 2026 GEO araştırması: FAQPage,
 * AI yanıtlarında en ağır ödüllendirilen şema tiplerinden. Bu helper aynı görünür FAQ
 * dizisini şemaya bağlar (tek SSoT → görünür bölüm + schema drift'siz).
 *
 * Mapping: { soru, cevap } → Question / acceptedAnswer.Answer.
 * Boş soru/cevap filtrelenir. Dizi boşsa null döner (script render edilmez).
 *
 * @module shared/schema/faqPageSchema
 */

export interface FaqItem {
  soru: string;
  cevap: string;
}

export function buildFaqPageSchema(faqlar: readonly FaqItem[] | FaqItem[]) {
  const liste = (faqlar || []).filter((f) => f && f.soru && f.cevap);
  if (liste.length === 0) return null;
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    inLanguage: 'tr-TR',
    mainEntity: liste.map((f) => ({
      '@type': 'Question',
      name: f.soru,
      acceptedAnswer: {
        '@type': 'Answer',
        text: f.cevap
      }
    }))
  };
}
